module.exports = __webpack_public_path__ + "img/photo.ba0a8fe.jpg";